var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidAutoOs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2392,
    viewBox: ".333 .667 501.334 480",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "-21.471%",
    x2: "84.198%",
    y1: "37.806%",
    y2: "97.817%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.02
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.333 416.667c-17.68 0-32-14.32-32-32 0-5.814 1.547-11.28 4.267-15.974l202.667-352c5.52-9.573 15.866-16.026 27.733-16.026s22.213 6.453 27.733 16.026l202.667 352c2.72 4.694 4.267 10.16 4.267 15.974 0 17.68-14.32 32-32 32z",
    fill: "#03a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235 150v266.667h266.667z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.267 16.693-202.667 352c-2.72 4.694-4.267 10.16-4.267 15.974 0 17.68 14.32 32 32 32h202.667v-416c-11.867 0-22.213 6.453-27.733 16.026z",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235 150 181.333 320-10.666 10.667-170.667-64-170.667 64-10.666-10.667z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235 150 181.333 320-10.666 10.667-170.667-64",
    fill: "#e1e1e1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidAutoOs1);
export default __webpack_public_path__ + "static/media/android-auto-os-1.a753bb463930997360a6faa6879288c2.svg";
export { ForwardRef as ReactComponent };